module.exports = __webpack_public_path__ + "img/5.fe17b06e.png";